import type { Application, ApplicationStatus, ApplicationType } from "./api";

export function initials(value?: string): string {
  return (value ?? "S").trim().slice(0, 2).toUpperCase();
}

export function applicationTypeLabel(type: ApplicationType): string {
  return type === "native" ? "原生应用" : "Web 应用";
}

export function applicationStatusLabel(status: ApplicationStatus): string {
  return {
    active: "运行中",
    disabled: "已停用",
    error: "同步失败",
    provisioning: "配置中",
  }[status];
}

export function formatDate(timestamp: number): string {
  return new Intl.DateTimeFormat("zh-CN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(timestamp);
}

export function applicationSearchText(application: Application): string {
  return [
    application.name,
    application.description,
    application.appKey,
    application.clientId,
    application.tenantId,
  ].filter(Boolean).join(" ").toLocaleLowerCase();
}
